package dev.lingvo.site.nav

import com.varabyte.kobweb.core.PageContext
import kotlinx.browser.window

private external fun encodeURIComponent(value: String): String

/** Filters and a cursor, in the URL, so a view can be sent to somebody. */
object UrlState {

    /** `?a=1&b=2`, or empty. Blank values are not useful in a shared link. */
    fun toQuery(params: Map<String, String?>): String {
        val pairs = params.entries
            .mapNotNull { (key, value) ->
                value?.trim().orEmpty().takeIf(String::isNotEmpty)?.let { key to it }
            }
            .sortedBy { it.first }
            .joinToString("&") { (key, value) ->
                "${encodeURIComponent(key)}=${encodeURIComponent(value)}"
            }
        return if (pairs.isEmpty()) "" else "?$pairs"
    }

    fun replace(params: Map<String, String?>) = write(params) {
        window.history.replaceState(null, "", it)
    }

    fun push(params: Map<String, String?>) = write(params) {
        window.history.pushState(null, "", it)
    }

    fun read(ctx: PageContext, key: String): String? =
        ctx.route.queryParams[key]?.takeIf { it.isNotBlank() }

    private inline fun write(params: Map<String, String?>, block: (String) -> Unit) {
        runCatching { block(window.location.pathname + toQuery(params)) }
    }
}
